module.exports = __webpack_public_path__ + "assets/successStars-51f0ac.svg";